import React from 'react'

// Components
import MemberLives from '../MemberLives'

const MemberVips = () => {
  return <MemberLives type='vip' />
}

export default MemberVips
